<template>
    <router-link to="/user-management" tag="li"
        ><a
            ><i class="fa fa-user"></i><span>User Management</span></a
        ></router-link
    >
</template>

<script>
export default {
    name: "itembank-nav",

    components: {},

    data: function () {
        return { items: [] };
    },

    mounted: function () {},
};
</script>



// WEBPACK FOOTER //
// Navigation.vue?1ec79122